import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  CLINICS_ADD_CLINIC_USER_BEGIN,
  CLINICS_ADD_CLINIC_USER_SUCCESS,
  CLINICS_ADD_CLINIC_USER_FAILURE,
  CLINICS_ADD_CLINIC_USER_DISMISS_ERROR,
} from './constants';
import ApiService from '../../../common/services/ApiService';

export function addClinicUser(clinicId, args) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CLINICS_ADD_CLINIC_USER_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.addClinicUser(clinicId, args).then(
        (res) => {
          dispatch({
            type: CLINICS_ADD_CLINIC_USER_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CLINICS_ADD_CLINIC_USER_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddClinicUserError() {
  return {
    type: CLINICS_ADD_CLINIC_USER_DISMISS_ERROR,
  };
}

export function useAddClinicUser() {
  const dispatch = useDispatch();

  const { addClinicUserPending, addClinicUserError } = useSelector(
    state => ({
      addClinicUserPending: state.clinics.addClinicUserPending,
      addClinicUserError: state.clinics.addClinicUserError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((clinicId, args) => {
    return dispatch(addClinicUser(clinicId, args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissAddClinicUserError());
  }, [dispatch]);

  return {
    addClinicUser: boundAction,
    addClinicUserPending,
    addClinicUserError,
    dismissAddClinicUserError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLINICS_ADD_CLINIC_USER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        addClinicUserPending: true,
        addClinicUserError: null,
      };

    case CLINICS_ADD_CLINIC_USER_SUCCESS:
      // The request is success
      return {
        ...state,
        addClinicUserPending: false,
        addClinicUserError: null,
      };

    case CLINICS_ADD_CLINIC_USER_FAILURE:
      // The request is failed
      return {
        ...state,
        addClinicUserPending: false,
        addClinicUserError: action.data.error,
      };

    case CLINICS_ADD_CLINIC_USER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        addClinicUserError: null,
      };

    default:
      return state;
  }
}
